import type { OpenLibraryBook } from '../types/models'

// Bounded so the user never waits on a spinner forever. Failures must throw, not return []; a 4xx other than 429 means no results.
const SEARCH_TIMEOUT_MS = 12_000
const MIN_QUERY_LENGTH = 3

export async function searchBooks(query: string): Promise<OpenLibraryBook[]> {
  if (query.length < MIN_QUERY_LENGTH) return []
  const url = `https://openlibrary.org/search.json?title=${encodeURIComponent(query)}&limit=10&fields=key,title,author_name,first_publish_year,cover_i`
  const res = await fetch(url, { signal: AbortSignal.timeout(SEARCH_TIMEOUT_MS) })
  if (res.status >= 400 && res.status < 500 && res.status !== 429) return []
  if (!res.ok) throw new Error(`Catalogue search failed (${res.status})`)
  const data = await res.json()
  return data.docs ?? []
}
